<div class="flex flex-col w-full h-full shadow-sm rounded-3xl p-6 gap-6 bg-white">
    <div class="flex flex-col w-full h-auto gap-4">
        <div class="flex flex-row w-full h-auto gap-4">
            <div class="flex flex-col w-full h-auto gap-2">
                <span class="font-semibold text-xl">Productos Relacionados</span>
                <span class="text-sm">Elige los complementos ideales desde nuestro catálogo.</span>
            </div>
            <div class="flex flex-row w-auto h-auto rounded-2xl pt-2 pb-2 pr-4 pl-4 gap-3 cursor-pointer" (click)="showCatalog()">
                <div class="flex flex-col w-auto h-auto">
                    <i class="fi-rr-arrow-small-left text-2xl"> </i>
                </div>
                <span class="font-semibold text-lg">Volver</span>
            </div>
        </div>
        <div class="flex flex-row w-full h-auto gap-2 justify-start">
            <app-custom-input [(value)]="searchTerm" placeholder="Ingresa el nombre del producto..."></app-custom-input>
            <app-button (clickButton)="onSearch({page:0, first:0, rows:10})" label="Buscar"   [disabled]="searchTerm.length < 3 || itemList.length === 0"></app-button>
            <app-button label="Limpiar" color="red-500" icon="fi-rr-eraser" (clickButton)="cleanFilter()"></app-button>
        </div>
    </div>
    @if (itemList && itemList.length > 0) {
    <div class="card">
        <p-table #customTable [value]="[{}]" [paginator]="true" [rows]="rows" [first]="first" [lazy]="true"
            [lazyLoadOnInit]="false" (onLazyLoad)="loadItems($event)" [totalRecords]="totalItems"  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                 [showCurrentPageReport]="true">
            <ng-template pTemplate="body" let-item>
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-4">
                    @for (product of itemList; track product.id) {
                    <div (click)="openProductDetailDialog(product)"
                        class="flex flex-col  border-gray-chateau-100  p-4 gap-4 rounded-2xl  bg-white hover:bg-gray-100 shadow-[0_4px_8px_0_#00000029] cursor-pointer justify-between">
                        <div class="rounded-2xl flex flex-col justify-center items-center">
                            <img [src]="product.productImage || '/asset/imagen-no-disponible-1.jpg'" width="100" height="100"
                                alt="{{ product.name }}" class="opacity-80 rounded-lg object-cover" />
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="flex flex-col gap-0.5">
                              <span class="font-semibold text-sm">{{ product.name }}</span>
                              <span class="text-[11px] text-gray-500">ID: {{ product.id }}</span>
                              @if (product.dimensions) {
                              <span class="text-xs text-gray-600">{{ product.dimensions }} mm</span>
                              }
                            </div>
                            <div class="flex flex-col gap-1 text-xs">
                              @if (product.thickness) {
                              <div class="flex flex-row gap-2">
                                <span class="text-gray-700">Espesor:</span>
                                <span class="font-medium">{{ product.thickness }} mm</span>
                              </div>
                              }
                              @if (product.color && product.color.name) {
                              <div class="flex flex-row gap-2">
                                <span class="text-gray-700">Diseño:</span>
                                <span class="font-medium">{{ product.color.name }}</span>
                              </div>
                              }
                              @if (product.texture && product.texture !== 'NA') {
                              <div class="flex flex-row gap-2">
                                <span class="text-gray-700">Textura:</span>
                                <span class="font-medium">{{ product.texture }}</span>
                              </div>
                              }
                                                            @if (product.faceOne || product.faceTwo) {
                                                            <div class="flex flex-row gap-2">
                                                                <span class="text-gray-700">Caras:</span>
                                                                <span class="font-medium">{{ getProductCoating(product) }}</span>
                                                            </div>
                                                            }
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </ng-template>
        </p-table>
    </div>
    } @else {
    <div class="bg-yellow-100 p-4 rounded-2xl">
        No hay registros
    </div>
    }
</div>
